import { render, staticRenderFns } from "./NewRequestUrl.vue?vue&type=template&id=628cbea4&scoped=true"
import script from "./NewRequestUrl.vue?vue&type=script&lang=ts"
export * from "./NewRequestUrl.vue?vue&type=script&lang=ts"
import style0 from "./NewRequestUrl.vue?vue&type=style&index=0&id=628cbea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628cbea4",
  null
  
)

export default component.exports